import { Capacitor } from '@capacitor/core'
import { EvergreenWealthLogo } from '@egw/assets'
import { Link } from '@egw/components'
import { WEALTH_ROUTES } from '@egw/constants'
import { useTranslation } from '@egw/i18n'
import { XMarkIcon } from '@heroicons/react/24/solid'
import cn from 'classnames'
import { type FC } from 'react'

export const UnauthenticatedHeader: FC<{
  closeHandler?: () => void | Promise<void>
}> = ({ closeHandler }) => {
  const { t } = useTranslation('layouts')

  return (
    <div
      className={cn('p-sm bg-black items-center gap-sm flex z-20', {
        'pt-14': Capacitor.isNativePlatform(),
      })}
    >
      <div className="flex-1 flex justify-between items-center">
        <Link href={WEALTH_ROUTES.OVERVIEW.path} title={t('header.home_link_title')}>
          <EvergreenWealthLogo className="h-3" />
        </Link>

        {closeHandler ? (
          <button
            className="opacity-70 hover:opacity-100"
            type="button"
            onClick={() => {
              void closeHandler()
            }}
            data-testid="unauthenticated-header-close_button"
          >
            <XMarkIcon className="text-white w-5 h-5" />
          </button>
        ) : null}
      </div>
    </div>
  )
}
